/* eslint-disable */
import {
  createStyles,
  Theme,
  withStyles,
} from "@material-ui/core";
import { withTranslation } from "react-i18next";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import  { Component } from "react";
import { connect } from "react-redux";

import {
  getAllProperties,
  edit_Properties,
  edit_Properties_list,
} from "../../../utils/store/actions/users.actions";
import {
  getEnums,
  getEnumsFiltered,
} from "../../../utils/store/actions/survey.action";
import GeneralProperties from "./Properties/GeneralProperties";
import InputProperties from "./Properties/InputProperties";
import EmailProperties from "./Properties/EmailProperties";
import GdprTemplateConfiguration from "./Properties/GdprTemplateConfiguration";
import InvestorColorProperties from "./Properties/InvestorColorProperties";
import PopUpProperties from "./Properties/PopUpProperties";
import DocumentTooltips from "./Properties/DocumentTooltips";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: "20px",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    chips: {
      display: "flex",
      flexWrap: "wrap",
    },
    chip: {
      margin: 2,
    },
    accordion: {
      borderRadius: "10px",
      boxShadow: "none",
    },
  });
class PropertiesConfiguration extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }
  async componentDidMount() {
    await this.props.getEnums();
    await this.props.getEnumsFiltered();
  }


  render() {
    const { classes, t } = this.props;
    return (
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="modules"
        >
          <Typography className={classes.heading}>{t("PROPERTIES")}</Typography>
        </AccordionSummary>
        <div
          style={{ display: "flex", flexDirection: "column", padding: "10px" }}
        >
          <GeneralProperties/>
          <InputProperties/>
          <EmailProperties/>
          <GdprTemplateConfiguration />
          <InvestorColorProperties />
          <PopUpProperties/>
          <DocumentTooltips/>
        </div>
      </Accordion>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getEnums,
  getEnumsFiltered,
  getAllProperties,
  edit_Properties,
  edit_Properties_list,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(PropertiesConfiguration)));
